export const ARRIVAL_STOP_TYPES = [
    'pickup_empty_arrival',
    'pickup_arrival',
    'deliver_arrival',
    'deliver_empty_arrival',
    'offsite_pickup_arrival',
    'offsite_deliver_arrival',
    'offsite_pickup_empty_arrival',
    'offsite_deliver_empty_arrival'
];
